export const BUSINESS_ACCOUNTS_SLICE_NAME = "businessAccounts"
